let navigation = {
    init: function(){ 
        jQuery('.c-nav-toggle').click(function(e){
            jQuery('body').toggleClass('body-overflow');
            jQuery('.c-subnav-wrapper button').removeClass('c-subnav-active-btn');
            jQuery('.c-nav-subnav').removeClass('c-subnav-active');  
        })
         
        jQuery('.c-subnav-wrapper button').click(function(e){
            e.preventDefault(); 
            if(jQuery(this).hasClass('c-subnav-active-btn')){ 
                jQuery('.c-subnav-wrapper button').removeClass('c-subnav-active-btn');
                jQuery('.c-nav-subnav').removeClass('c-subnav-active');
            }else{
                jQuery('.c-subnav-wrapper button').removeClass('c-subnav-active-btn');
                jQuery('.c-nav-subnav').removeClass('c-subnav-active');
                jQuery(this).addClass('c-subnav-active-btn');
                jQuery(this).parent().siblings('.c-nav-subnav').addClass('c-subnav-active');
            }   
        })

        jQuery(window).resize(function(){
            jQuery('body').removeClass('body-overflow');
            jQuery('.c-subnav-wrapper button').removeClass('c-subnav-active-btn');
            jQuery('.c-nav-subnav').removeClass('c-subnav-active');
        })
    }
}